/**
 * Logger - minimal leveled logger with scopes
 *
 * Usage:
 *   import Logger from '@utils/Logger.js'
 *   const log = Logger.scope('ApiService')
 *   log.info('message', data)
 */

const levels = ['debug', 'info', 'warn', 'error'];

function getLevel() {
  try {
    const stored = localStorage.getItem('logLevel');
    if (stored && levels.includes(stored)) return stored;
  } catch {}
  // Default based on env flags
  const dev = import.meta?.env?.DEV;
  const enableDebug = import.meta?.env?.VITE_ENABLE_DEBUG === 'true' || (typeof localStorage !== 'undefined' && localStorage.getItem('enableVerboseLogs') === 'true');
  return dev || enableDebug ? 'debug' : 'info';
}

function shouldLog(targetLevel) {
  const current = getLevel();
  return levels.indexOf(targetLevel) >= levels.indexOf(current);
}

function format(scope, level, args) {
  const prefix = scope ? `[${scope}]` : '';
  return [`${prefix}`, ...args];
}

const Logger = {
  level: getLevel(),
  setLevel(lvl) {
    if (levels.includes(lvl)) {
      this.level = lvl;
      try { localStorage.setItem('logLevel', lvl); } catch {}
    }
  },
  scope(name) {
    return {
      debug: (...args) => { if (shouldLog('debug')) console.debug(...format(name, 'debug', args)); },
      info: (...args) => { if (shouldLog('info')) console.info(...format(name, 'info', args)); },
      warn: (...args) => { if (shouldLog('warn')) console.warn(...format(name, 'warn', args)); },
      error: (...args) => { if (shouldLog('error')) console.error(...format(name, 'error', args)); }
    };
  },
  debug: (...args) => { if (shouldLog('debug')) console.debug(...args); },
  info: (...args) => { if (shouldLog('info')) console.info(...args); },
  warn: (...args) => { if (shouldLog('warn')) console.warn(...args); },
  error: (...args) => { if (shouldLog('error')) console.error(...args); }
};

export default Logger;

